import React, {memo, useEffect, useRef, useState} from 'react';
import {useDebounceEffect} from '../../../hoc/useDebounceEffect'
import {canvasPreview} from './canvasPreview'
import 'react-image-crop/dist/ReactCrop.css'
import {Button, Stack} from "@mui/material";
import {Cropper} from "react-cropper";
import "cropperjs/dist/cropper.css";
import Divider from "@mui/material/Divider";
import IModal from "../Modal/IModal";


const IImageCropper = ({src, aspectRatio = 1, handleClose = undefined, setCropperState = undefined}) => {
    const [imgSrc, setImgSrc] = useState(src)
    const previewCanvasRef = useRef(null)
    const imgRef = useRef(null)
    const blobUrlRef = useRef('')
    const blobFileRef = useRef('')
    const [completedCrop, setCompletedCrop] = useState();
    const [zoom, setZoom] = useState(1)
    const cropperRef = useRef(null);

    useEffect(() => {
        if (src === null) return;
        const reader = new FileReader()
        reader.addEventListener('load', () =>
            setImgSrc(reader.result?.toString() || ''),
        )
        reader.readAsDataURL(src)
    }, [src])

    const onOkeyClickHandler = async () => {

        await cropperRef.current?.cropper.getCroppedCanvas().toBlob(async (blob) => {
            if (!blob) {
                throw new Error('Failed to create blob')
            }
            if (blobUrlRef.current) {
                await URL.revokeObjectURL(blobUrlRef.current)
            }
            blobFileRef.current = await blob;
            blobUrlRef.current = await URL.createObjectURL(blob)

            setCropperState({
                blobSrc: await URL.createObjectURL(blob),
                blobFile: await blob,
                orginalSrc: src,
                completedCrop: completedCrop,
                status: true
            });
        })
    }

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                // We use canvasPreview as it's much faster than imgPreview.
                await canvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                    zoom
                )
            }
        },
        100,
        [completedCrop],
    )

    const closeCropper = async () => {
        setCropperState({
            blobSrc: '',
            blobFile: null,
            orginalSrc: src,
            completedCrop: completedCrop,
            status: false
        });
        setZoom(1)
        handleClose();
    }

    const confirmCropper = async () => {
        await onOkeyClickHandler();
        handleClose();
    }

    return (
        <IModal open={src !== null}
                handleClose={closeCropper}
                showClose
        >
            {!!imgSrc && (
                <div
                    style={{overflow: 'hidden'}}
                    id={'div_main_cropper'}
                >
                    <Cropper
                        ref={cropperRef}
                        style={{height: 400, width: "100%"}}
                        zoomTo={0.5}
                        dragMode={'move'}
                        initialAspectRatio={1}
                        // preview=".img-preview"
                        src={imgSrc}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={true}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        guides={true}
                        aspectRatio={aspectRatio}

                    />
                </div>
            )}

            <div style={{display: 'none'}}>
                <canvas
                    ref={previewCanvasRef}
                    style={{
                        border: '1px solid black',
                        objectFit: 'contain',
                        width: completedCrop?.width ?? 0,
                        height: completedCrop?.height ?? 0,
                    }}
                />
            </div>

            <Divider sx={{width:'100%'}}/>

            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} maxWidth={'90%'} margin={2}>
                <Button variant={'contained'} className={'btn-success'} onClick={confirmCropper}>
                   ok
                </Button>
                <Button onClick={closeCropper} variant={'outlined'} className={'btn-border-error txt-error'}>
                    close
                </Button>
            </Stack>
        </IModal>
    );
};

export default memo(IImageCropper);